module.exports = __webpack_public_path__ + "img/zhaoxin.e8ae9fd7.jpg";